import { useEffect, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import { TextInput } from "../../components/shared/Inputs/TextInput";
import { useForm } from "react-hook-form";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";
import useLeads from "../../data/useLeads";
import { useNavigate } from "react-router-dom";

interface FormValues {
  vrm: string;
}

export default function FindLead() {
  const { setInfo } = usePageNameContext();
  const navigate = useNavigate();
  const { register, getValues, setValue, watch, handleSubmit, reset, control } = useForm<FormValues>({});
  // ignoreQuery: this page only ever needs one vehicle, so it searches server-side
  // rather than pulling the whole lead list down to the device on mount.
  const { searchByVrm } = useLeads(true, "FindLead");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setInfo({
      name: "Find a Lead",
      desc: "Search for a lead to view details and update the collection status",
    });
  }, []);

  const onSubmit = async (data: any) => {

    let formatted = data.vrm.replace(/\s/g, '').toUpperCase();

    if (!formatted) {
      setError("Enter a vehicle registration.");
      return;
    }

    setError(null);

    try {
      const response = await searchByVrm.mutateAsync(formatted);

      // The server matches registrations with a LIKE, so keep the exact-match check
      // here to preserve the previous behaviour of only navigating on an exact hit.
      const lead = response?.data?.leads?.find((lead) => lead.vehicle?.vrm === formatted);

      if (!lead) {
        setError("Lead not found!");
        return;
      }

      navigate(`/driver/lead/${lead.id}`);
    } catch {
      setError("Search failed. Please check your connection and try again.");
    }
  }

  return (
    <div className="mt-8">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="w-full md:w-[15vw]">
          <TextInput label="Vehicle Registration" register={register} registerName="vrm" />
        </div>
        <ButtonInput label="Search" isSubmit={true} onClick={undefined} classes="mt-4" isLoading={searchByVrm.isLoading} disabled={searchByVrm.isLoading} />
      </form>
      <p className="mt-4 text-red-500 text-lg font-base ">{error}</p>
    </div>
  );
}